
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-influencer-trends/[id]",
      function () {
        return require("private-next-pages/instagram-influencer-trends/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-influencer-trends/[id]"])
      });
    }
  